module.exports = __webpack_public_path__ + "static/BT-desktop-15-98b8422627bf7bd82c53a2e7ce1b1ec2.jpg";